import React from 'react';

import RetryNotification from '../RetryNotification/RetryNotification';

import { useTranslation } from '@hooks/useTranslations';
import {
  FraudPreventionRecommendation,
  PspConnector,
  RetryPaymentMethod,
  RetryPaymentStatus,
} from '@types-internal';

export type RetryPaymentDefaultProps = {
  retryPaymentUrl?: string;
  retryPaymentMethod: RetryPaymentMethod;
  retryPaymentStatus?: RetryPaymentStatus;
  orderId: string;
  connector: PspConnector;
  pspToken?: string;
  amount: number;
  currency: string;
  siteId: number;
  sid?: string;
  customerId: string;
  fraudPreventionRecommendation?: FraudPreventionRecommendation;
};
const RetryPaymentDefault: React.FC<RetryPaymentDefaultProps> = ({
  retryPaymentUrl,
  retryPaymentMethod,
  retryPaymentStatus,
  orderId,
  connector,
  pspToken,
  amount,
  currency,
  siteId,
  sid,
  customerId,
  fraudPreventionRecommendation,
}) => {
  const { t } = useTranslation();
  //do not show the retry component when payment is already succesful or is being processed for that order
  if (retryPaymentStatus === 'SUCCESSFUL' || retryPaymentStatus === 'PROCESSING') return null;

  return (
    <RetryNotification
      type="warning"
      id="paymentRedirectButton"
      ariaLabel={t('mzp.order.detail.retry.payment.accessibility.label')}
      linkText={t('mzp.order.detail.retry.payment.button', {
        0: t(`general.payment.${retryPaymentMethod.toLowerCase()}`),
      })}
      linkUrl={retryPaymentUrl}
      linkDataZta="retryPaymentLink"
      retryPaymentMethod={retryPaymentMethod}
      orderId={orderId}
      connector={connector}
      pspToken={pspToken}
      amount={amount}
      sid={sid}
      currency={currency}
      siteId={siteId}
      customerId={customerId}
      fraudPreventionRecommendation={fraudPreventionRecommendation}>
      {t('mzp.order.detail.payment.reminder.warning', {
        0: t('mzp.order.detail.retry.payment.button', {
          0: t(`general.payment.${retryPaymentMethod.toLowerCase()}`),
        }),
      })}
    </RetryNotification>
  );
};

export default RetryPaymentDefault;
